/**
 * Знак дисциплины. Форма читается до чтения, поэтому колонки «спорт» нет.
 *
 * Коды бэкенда и имена знаков совпадают не везде: движок называет футбол
 * `soccer`, Dota — `dota2`. Разводить их таблицей здесь, а не переименовывать
 * что-то одно: коды дисциплин уходят в базу и в дельту, а имена файлов знаков —
 * в макет, и связывать эти два срока жизни нельзя.
 */

import { sportCanon } from '../lib/sports';

import { SIGNS } from './signs';

const ALIAS: Record<string, string> = {
  dota2: 'dota',
  soccer: 'football',
  rsix: 'r6',
  sc2: 'starcraft',
  'table-tennis': 'tabletennis',
  'american-football': 'football',
  tabletennis: 'tabletennis',
  esport: 'esports',
};

function signPath(raw: string | undefined): string | undefined {
  if (raw === undefined || raw === '') return undefined;
  const canon = sportCanon(raw);
  if (canon === '' || canon === 'other') return undefined;
  const key = ALIAS[canon] ?? canon;
  return SIGNS[key];
}

export function Sign({
  sport,
  name,
}: {
  sport: string | undefined;
  name?: string | undefined;
}): React.ReactElement {
  // Зеркало шлёт корзину `other` и живое имя в `sportName` («Cricket»).
  // Код без хвоста — не дисциплина; имя ещё может узнать знак.
  const path = signPath(sport) ?? signPath(name) ?? SIGNS.other!;
  return (
    <span className="nx-fk__sig" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d={path} />
      </svg>
    </span>
  );
}
